import type { Deck } from "."

export const deckIds: Deck.Id[] = ["ankle_deep", "waist_deep", "neck_deep"]
